export const smokingprefrence = [
    { name: 'YES', code: true },
    { name: 'NO', code: false },
]